/**
 * Check input amount (valid)
 * @param element
 */
window.checkInputAmount = function (element) {
    let max = 999;
    if (typeof $(element).attr('max') !== 'undefined') {
        max = parseInt($(element).attr('max'));
    }

    $(element).val(parseInt($(element).val()));
    if ($(element).val() === 'NaN' || $(element).val() < 1) {
        $(element).val(1);
    } else {
        if (parseInt($(element).val()) > max) {
            $(element).val(max);
        }
    }
};

/**
 * add to basket
 * @param action
 * @param articleID
 * @param amount
 */
window.basketControl = function (action, articleID, amount) {
    $.ajax({
        url: MP_PATH + 'ajax/helper/ajax.shop_basketControl.php',
        type: 'post',
        dataType: 'json',
        data: {
            action: action,
            id: articleID,
            amount: amount
        },
        success: function (res) {
            if (typeof ListBasket !== 'undefined') {
                ListBasket.updater();
            }

            if (res.amount > 0) {
                $('#basket-amount').show().html(res.amount);
            } else {
                $('#basket-amount').html(0).hide();
            }

            if (action !== 3) {
                $('#added-product').show();
            }
        }
    });
};